import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function RodoPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <section className="pt-24 md:pt-32 pb-10 md:pb-14">
          <div className="px-4 md:px-8 lg:px-12 max-w-3xl mx-auto">
            <Breadcrumb />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-primary-500 mb-3 block">Dokumenty</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-6">
              Obowiązek informacyjny RODO
            </h1>
            <p className="text-sm text-foreground-500 mb-8">Ostatnia aktualizacja: 25 lipca 2026</p>
          </div>
        </section>

        <section className="pb-16 md:pb-24">
          <div className="px-4 md:px-8 lg:px-12 max-w-3xl mx-auto">
            <div className="flex flex-col gap-8 text-sm md:text-base text-foreground-700 leading-relaxed">

              <div>
                <p className="mb-3">
                  Zgodnie z art. 13 ust. 1 i ust. 2 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych (RODO), informujemy, że:
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">1. Administrator danych</h2>
                <p>
                  Administratorem Państwa danych osobowych jest <strong>Jan Wojdyła</strong>, prowadzący działalność gospodarczą pod adresem: ul. Dworcowa 11A, 38-500 Sanok. Kontakt z administratorem możliwy jest poprzez e-mail: <strong>biuro@kredytpodkarpacie.pl</strong> oraz telefonicznie: <strong>698 084 044</strong>.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">2. Cel i podstawa prawna przetwarzania</h2>
                <p className="mb-2">Państwa dane osobowe przetwarzane będą w następujących celach:</p>
                <ul className="list-disc pl-5 flex flex-col gap-1.5">
                  <li><strong>Świadczenie usług eksperta kredytowego</strong> — na podstawie art. 6 ust. 1 lit. b RODO (niezbędność do wykonania umowy lub podjęcia działań przed jej zawarciem)</li>
                  <li><strong>Odpowiedź na zapytania przez formularz kontaktowy</strong> — na podstawie art. 6 ust. 1 lit. f RODO (prawnie uzasadniony interes administratora)</li>
                  <li><strong>Wypełnienie obowiązków prawnych</strong> — na podstawie art. 6 ust. 1 lit. c RODO (obowiązek prawny ciążący na administratorze, np. przepisy podatkowe)</li>
                  <li><strong>Prowadzenie korespondencji</strong> — na podstawie art. 6 ust. 1 lit. f RODO (prawnie uzasadniony interes)</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">3. Kategorie przetwarzanych danych</h2>
                <p className="mb-2">Przetwarzamy następujące kategorie danych osobowych:</p>
                <ul className="list-disc pl-5 flex flex-col gap-1.5">
                  <li>Dane identyfikacyjne (imię, nazwisko)</li>
                  <li>Dane kontaktowe (numer telefonu, adres e-mail)</li>
                  <li>Dane finansowe (dochody, zobowiązania, historia kredytowa) — wyłącznie za odrębną zgodą klienta</li>
                  <li>Dane dotyczące preferencji kredytowych i celów finansowych</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">4. Okres przechowywania danych</h2>
                <p>
                  Dane osobowe będą przechowywane przez okres niezbędny do realizacji celów, dla których zostały zebrane, a po tym okresie — przez czas wymagany przepisami prawa (np. archiwizacja dokumentacji księgowej przez 5 lat) lub do momentu przedawnienia ewentualnych roszczeń.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">5. Odbiorcy danych</h2>
                <p className="mb-2">Państwa dane osobowe mogą być przekazywane:</p>
                <ul className="list-disc pl-5 flex flex-col gap-1.5">
                  <li>Bankom i instytucjom finansowym — wyłącznie na podstawie odrębnej, dobrowolnej zgody i w zakresie niezbędnym do procesu kredytowego</li>
                  <li>Podmiotom świadczącym usługi IT i hostingowe na rzecz administratora</li>
                  <li>Organom państwowym — wyłącznie na podstawie przepisów prawa</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">6. Prawa przysługujące osobom, których dane dotyczą</h2>
                <p className="mb-2">Przysługuje Państwu prawo do:</p>
                <ul className="list-disc pl-5 flex flex-col gap-1.5">
                  <li>Dostępu do treści swoich danych (art. 15 RODO)</li>
                  <li>Sprostowania danych (art. 16 RODO)</li>
                  <li>Usunięcia danych — „prawo do bycia zapomnianym" (art. 17 RODO)</li>
                  <li>Ograniczenia przetwarzania (art. 18 RODO)</li>
                  <li>Przenoszenia danych (art. 20 RODO)</li>
                  <li>Wniesienia sprzeciwu wobec przetwarzania (art. 21 RODO)</li>
                  <li>Wniesienia skargi do organu nadzorczego — Prezesa Urzędu Ochrony Danych Osobowych (art. 77 RODO)</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">7. Dobrowolność podania danych</h2>
                <p>
                  Podanie danych osobowych jest dobrowolne, jednak niezbędne do świadczenia usług eksperta kredytowego. Konsekwencją niepodania danych będzie brak możliwości realizacji usługi.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">8. Zautomatyzowane podejmowanie decyzji</h2>
                <p>
                  Państwa dane osobowe nie będą podlegały zautomatyzowanemu podejmowaniu decyzji, w tym profilowaniu, w rozumieniu art. 22 RODO.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">9. Przekazywanie danych poza EOG</h2>
                <p>
                  Państwa dane osobowe nie będą przekazywane do państw trzecich (poza Europejski Obszar Gospodarczy) ani do organizacji międzynarodowych.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">10. Kontakt w sprawach RODO</h2>
                <p>
                  W sprawach dotyczących ochrony danych osobowych prosimy o kontakt:
                </p>
                <ul className="list-disc pl-5 flex flex-col gap-1.5 mt-2">
                  <li>E-mail: <strong>biuro@kredytpodkarpacie.pl</strong></li>
                  <li>Telefon: <strong>698 084 044</strong></li>
                  <li>Adres: <strong>ul. Dworcowa 11A, 38-500 Sanok</strong></li>
                </ul>
              </div>

            </div>

            <div className="mt-12 pt-8 border-t border-background-200 text-center">
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-up-line" />
                Powrót na górę strony
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
